import React, { useEffect } from 'react';

const ReturnPage: React.FC = () => {
  useEffect(() => {
     //Attempt to close the popup
    if (window.opener) {
      window.close();
    } else {
      console.log('Cannot close popup: no opener reference.');
    }
  }, []);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>Your order is being processed!</h1>
      <p>This window will close soon.</p>
    </div>
  );
};

export default ReturnPage;